// extracted by mini-css-extract-plugin
export var blink = "_6h-2";
export var cursor = "_6h-1";
export var reactMarkdown = "_6h-3";
export var streamingText = "_6h-0";